import { configureStore } from '@reduxjs/toolkit'
import dashboardTitle from './actions/dashboardTitle'
import userTypeSlice from './actions/userTypeSlice'
import inboundShipmentsSlice from './actions/inbound-shipments/inboundShipmentsSlice'
import user from './userSlice';
import globalFilterReducer from './globalFilterSlice';
import filterDrawerReducer from './filterDrawerSlice';
export const store = configureStore({
  reducer: {
    dashboardDetails: dashboardTitle,
    userCardType: userTypeSlice,
    inboundShipments: inboundShipmentsSlice,
    globalFilter: globalFilterReducer,
    filterDrawer: filterDrawerReducer,
    user,
  },
})